import { DependencyTrackVulnerabilityFindingData } from 'component/details/requirement-intake/requirements-detail/findings/list/findings-list.model';

export interface FindingSummary {
  name?: string;
  type?: string | null;
  data?: string | null;
}

export interface DependencyTrackFindingSummary {
  type?: string | null;
  data?: string | null;
}

export interface DependencyTrackPayload {
  analysis?: {
    isSuppressed?: boolean;
  };
  component?: {
    name?: string;
    version?: string;
    latestVersion?: string;
    purl?: string;
  };
  vulnerability?: DependencyTrackVulnerability;
}

export interface DependencyTrackVulnerability {
  vulnId?: string;
  source?: string;
  severity?: string;
  cvssV3BaseScore?: number;
  epssScore?: number;
  epssPercentile?: number;
  published?: number;
  cwes?: Array<{
    cweId?: number;
    name?: string;
  }>;
  aliases?: Array<Record<string, string>>;
}

export function prettyPrintJson(data?: string | null): string {
  if (!data) {
    return '';
  }

  try {
    return JSON.stringify(JSON.parse(data), null, 2);
  } catch {
    return data;
  }
}

export function getDependencyTrackVulnerabilityData(
  finding: DependencyTrackFindingSummary,
): DependencyTrackVulnerabilityFindingData | undefined {
  if (finding.type !== 'DEPENDENCY_TRACK_VULNERABILITY' || !finding.data) {
    return undefined;
  }

  try {
    const data = JSON.parse(finding.data) as DependencyTrackPayload;

    return {
      componentName: data.component?.name,
      componentVersion: data.component?.version,
      componentLatestVersion: data.component?.latestVersion,
      vulnerabilitySource: data.vulnerability?.source,
      cvssV3BaseScore: data.vulnerability?.cvssV3BaseScore,
      epssScore: data.vulnerability?.epssScore,
      epssPercentile: data.vulnerability?.epssPercentile,
      cwes: data.vulnerability?.cwes
        ?.map((cwe) =>
          [cwe.cweId ? `CWE-${cwe.cweId}` : undefined, cwe.name].filter(Boolean).join(': '),
        )
        .filter((cweEntry) => cweEntry.length > 0),
      isSuppressed: data.analysis?.isSuppressed,
      published: data.vulnerability?.published,
    };
  } catch {
    return undefined;
  }
}

export function getSeverityClass(severity?: string | null): string {
  return `severity-${(severity ?? 'unassigned').toLowerCase()}`;
}
